import { render, staticRenderFns } from "./opportunity-details-modal.vue?vue&type=template&id=2d4ebd4c"
import script from "./opportunity-details-component.ts?vue&type=script&lang=ts&external"
export * from "./opportunity-details-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4ebd4c')) {
      api.createRecord('2d4ebd4c', component.options)
    } else {
      api.reload('2d4ebd4c', component.options)
    }
    module.hot.accept("./opportunity-details-modal.vue?vue&type=template&id=2d4ebd4c", function () {
      api.rerender('2d4ebd4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/plant-item-opportunity-details-modal/opportunity-details-modal.vue"
export default component.exports